export default __webpack_public_path__ + "static/media/community_desexing.f8d6a77b.png";